export default __webpack_public_path__ + "static/1841-d999709485b06177bde05f471b2353a0.gif";